import React from 'react';
import SidebarSkeleton from './SidebarSkeleton';
import HeaderSkeleton from './HeaderSkeleton';

/**
 * LayoutSkeleton combines the Sidebar and Header skeletons 
 * to represent the loading state of the main application layout.
 */
const LayoutSkeleton = () => {
  return (
    <div className="layout-skeleton flex h-screen">
      {/* Sidebar Skeleton */}
      <div className="layout-skeleton__sidebar flex-shrink-0">
        <SidebarSkeleton />
      </div>
      
      {/* Main Content Skeleton Area */}
      <div className="layout-skeleton__main flex-1 flex flex-col overflow-hidden">
        {/* Header Skeleton */}
        <HeaderSkeleton />
        
        {/* Content Area Placeholder (optional, could add a simple pulse here too) */}
        <main className="layout-skeleton__content flex-1 overflow-auto bg-gray-100 animate-pulse">
          {/* You could add more specific content skeleton elements here if needed */}
        </main>
      </div>
    </div>
  );
};

export default LayoutSkeleton; 